import React, { useState } from "react";
import zrvbanner from "../assets/zrvad.webp";
import "../style/Gravite.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const ZRV = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    buyingTime: "",
    agree: false,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      setPopupType("error");
      setPopupMessage("Please accept the marketing consent.");
      setShowPopup(true);
      return;
    }

    try {
      await addDoc(collection(db, "zrvLeads"), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        state: formData.state,
        city: formData.city,
        buyingTime: formData.buyingTime,
        agree: formData.agree,
        offer: "Honda ZR-V",
        createdAt: serverTimestamp(),
      });

      setPopupType("success");
      setPopupMessage(
        "Thank you! Your details have been submitted successfully."
      );
      setShowPopup(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        state: "",
        city: "",
        buyingTime: "",
        agree: false,
      });
    } catch (error) {
      console.error(error);

      setPopupType("error");
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  return (
    <div className="gravite-page">
      {/* HERO */}
      <div className="gravite-hero">
        <div className="hero-image">
          <img src={zrvbanner} alt="Honda ZR-V" />
        </div>

        <form className="lead-form" onSubmit={handleSubmit}>
          <h2>Get Expert Advice Now</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <label className="small-label">
            How soon are you looking to buy?
          </label>

          <select
            name="buyingTime"
            value={formData.buyingTime}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="Within 1 Month">Within 1 Month</option>
            <option value="1-3 Months">1-3 Months</option>
            <option value="3-6 Months">3-6 Months</option>
            <option value="6+ Months">6+ Months</option>
          </select>

          <div className="checkbox-row">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              By submitting this form, you agree that your data may be used for
              marketing purposes.
            </span>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* ABOUT */}
      <section className="about-gravite">
        <h2>Experience the New Honda ZR-V</h2>

        <p>
          The Honda ZR-V is a premium midsize SUV that blends sporty styling,
          advanced hybrid technology, and premium comfort. Positioned between
          the HR-V and CR-V globally, the ZR-V is powered by Honda's acclaimed
          e:HEV strong hybrid system, delivering excellent fuel efficiency,
          refined performance, and low emissions. With premium interiors,
          connected features, Honda Sensing ADAS, and a spacious cabin, the
          ZR-V is designed for buyers seeking a sophisticated urban SUV.
        </p>
      </section>

      {/* TABLE */}
      <section className="tech-data">
        <h2>Technical Specifications of the Honda ZR-V</h2>

        <table>
          <thead>
            <tr>
              <th>Specification</th>
              <th colSpan="4">Honda ZR-V</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Expected Price</td>
              <td colSpan="4">₹30–35 Lakh (Ex-Showroom)</td>
            </tr>

            <tr>
              <td>Engine</td>
              <td colSpan="4">2.0L Petrol e:HEV Hybrid</td>
            </tr>

            <tr>
              <td>Power</td>
              <td colSpan="4">184 PS (Combined Output)</td>
            </tr>

            <tr>
              <td>Torque</td>
              <td colSpan="4">315 Nm</td>
            </tr>

            <tr>
              <td>Transmission</td>
              <td colSpan="4">e-CVT Automatic</td>
            </tr>

            <tr>
              <td>Drive Type</td>
              <td colSpan="4">Front-Wheel Drive (FWD)</td>
            </tr>

            <tr>
              <td>Fuel Efficiency</td>
              <td colSpan="4">Approx. 22–24 km/l</td>
            </tr>

            <tr>
              <td>Infotainment</td>
              <td colSpan="4">10.2-inch Touchscreen</td>
            </tr>

            <tr>
              <td>Instrument Cluster</td>
              <td colSpan="4">10.2-inch Digital Display</td>
            </tr>

            <tr>
              <td>Safety</td>
              <td colSpan="4">
                Honda Sensing ADAS, 6 Airbags, 360° Camera, Lane Keep Assist
              </td>
            </tr>

            <tr>
              <td>Boot Space</td>
              <td colSpan="4">Approx. 380 Litres</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* CUSTOM POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div
              className={`popup-icon ${
                popupType === "success" ? "success" : "error"
              }`}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>

            <h3>
              {popupType === "success"
                ? "Submitted Successfully"
                : "Submission Failed"}
            </h3>

            <p>{popupMessage}</p>

            <button
              className="popup-btn"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ZRV;